import { SET_SNACKBAR, SET_DIALOG, SET_WARNING_POPUP } from "./commonActionTypes";
import { DialogConfigInterface, WarningPopupConfigInterface } from "./type";

export const setSnackbar = (data: { type: "success" | "error"; message: any } | null) => {
	return {
		type: SET_SNACKBAR,
		data,
	};
};

export const setDialog = (open: boolean, data?: DialogConfigInterface) => {
	return {
		type: SET_DIALOG,
		data,
		open,
	};
};

export const setWarningPopup = (open: boolean, data?: WarningPopupConfigInterface) => {
	return {
		type: SET_WARNING_POPUP,
		data,
		open,
	};
};
